const UploadReportIcon = props => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="#A8ADB2"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.4286 17.4706H16.5714V12.1765H20L14 6L8 12.1765H11.4286V17.4706ZM8 19.2353H20V21H8V19.2353Z" />
  </svg>
)

export default UploadReportIcon
